import { DEFAULT_VALUE_OPTION, instance4 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import { useState, useEffect } from "react";

const getAllMasterGudangUtama = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

const useInitialMasterGudangUtama = (
  withSearch = false,
  url = "/wmsmaster/gudang/read"
) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Gudang Utama");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllMasterGudangUtama(url);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Gudang Utama",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [withSearch, url]);

  return state;
};

export default useInitialMasterGudangUtama;
